module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: " weex-el weex-text",
    class: ['dof-text', _vm.textTheme, _vm.hasTextMargin ? 'margin-text' : ''],
    style: (_vm._processExclusiveStyle(_vm.themeStyle, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.textValue))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-141f8197", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-141f8197","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-rich-text/dof-rich-text-text.vue
// module id = 567
// module chunks = 0 1